(function () {
  var SvgChartGlobal = MST;
  var SvgChartUtil = MST.SvgChartUtil;
  var SvgChartCache = MST.SvgChartCache;

  var SvgChartTechnical = function () {
    this.dataStatus = SvgChartTechnical.DATA_STATUS_INIT;
  };

  SvgChartTechnical.DATA_LOAD_TYPE_WITH_MAIN = 0;
  SvgChartTechnical.DATA_LOAD_TYPE_URL = 1;
  SvgChartTechnical.DATA_LOAD_TYPE_URL_DELAY = 2;
  SvgChartTechnical.DATA_ANALYSIS = 3;
  SvgChartTechnical.DATA_STATUS_INIT = 0;
  SvgChartTechnical.DATA_STATUS_LOADING = 1;
  SvgChartTechnical.DATA_STATUS_OK = 2;
  SvgChartTechnical.DATA_STATUS_FAILURE = 3;
  SvgChartTechnical.DATA_STATUS_NO_DATA = 4;
  SvgChartTechnical.DATA_MAX_RETRY_COUNT = 3;

  SvgChartTechnical.prototype.view = null;
  SvgChartTechnical.prototype.code = null;
  SvgChartTechnical.prototype.name = null;
  SvgChartTechnical.prototype.label = null;
  SvgChartTechnical.prototype.data = null;
  SvgChartTechnical.prototype.dataLoadType = 0;
  SvgChartTechnical.prototype.dataLoadUrl = null;
  SvgChartTechnical.prototype.dataLoadName = null;
  SvgChartTechnical.prototype.dataRequest = null;
  SvgChartTechnical.prototype.dataStatus = 0;
  SvgChartTechnical.prototype.dataRetryCount = 0;
  SvgChartTechnical.prototype.dataColor = null;
  SvgChartTechnical.prototype.dataColorSelect = null;
  SvgChartTechnical.prototype.elements = null;

  SvgChartTechnical.prototype.isMainTechnical = function () {
    return this == this.view.chart.mainTechnical;
  };

  SvgChartTechnical.prototype.setLoadType = function (type, value) {
    this.dataLoadType = type;

    if (type == SvgChartTechnical.DATA_LOAD_TYPE_WITH_MAIN) {
      this.dataLoadName = value;
    } else if (type == SvgChartTechnical.DATA_LOAD_TYPE_URL) {
      this.dataLoadUrl = value;
    }
  };

  SvgChartTechnical.loadSuccess = function (technical, json) {
    if (json == null || !(json["data"] instanceof Array)) {
      technical.dataStatus = SvgChartTechnical.DATA_STATUS_FAILURE;
      technical.view.onTechnicalDataStatusChange(technical);
    }

    if (technical.name == "pick") {
      technical.data = json.objects;
    } else if (
      technical.name == "portfolioLine" ||
      technical.name == "portfolioMountain"
    ) {
      technical.data = [];

      for (var i = 0; i < data.objects.length; i++) {
        technical.data[i] = {
          date: json.objects[i].value_date,
          close: json.objects[i].total_value,
          dap: json.objects[i].daily_absolute_performance,
        };
      }
    } else {
      var data = [];
      var ric = json["ric"];
      var currentTime = new Date(json["current_time"]).toISOString();
      var currencyCode = json["currency_code"];

      if (json["data"] && json["data"] instanceof Array) {
        var list = json["data"];

        for (var k = 0; k < list.length; k++) {
          // if(list[k] && list[k] instanceof Array && list[k].length == 6){
          if (list[k] && list[k] instanceof Array) {
            // var date = new Date(list[k][0]).toISOString();
            var date = new Date(list[k][0]);
            var string = date.Format("yyyy-MM-dd");
            date = new Date(new Date(string).getTime()).toISOString();
            data[k] = {
              ric: ric,
              current_time: currentTime,
              currency_code: currencyCode,
              date: date,
              open: null,
              high: null,
              low: null,
              close: list[k][4],
              close_bak: list[k][4],
              dividend_bak: list[k][2],
              volume: list[k][3],
            };
          } else {
            var adj = 1;
            if (list[k].adjustment != null) adj = list[k].adjustment;
            var volume = null;
            if (list[k].volume != null) volume = list[k].volume / adj;
            var open = null;
            var high = null;
            var low = null;
            var close = null;
            if (list[k].open != null) open = list[k].open * adj;
            if (list[k].high != null) high = list[k].high * adj;
            if (list[k].low != null) low = list[k].low * adj;
            if (list[k].close != null) close = list[k].close * adj;
            data.push({
              date: new Date(list[k].date).toISOString(),
              open: open,
              high: high,
              low: low,
              close: close,
              volume: volume,
            });
          }
        }

        var isBenchmark = true;
        for (var key in technical.view.chart.benchmarkObjs) {
          if (technical.view.chart.benchmarkObjs[key].checked == true) {
            isBenchmark = true;
            break;
          }
        }
      }
      technical.data = data;
    }
    if (
      technical.data.length > 1 &&
      technical.data[0].date > technical.data[1].date
    ) {
      technical.data.reverse();
    }

    if (technical.data.length > 0) {
      if (technical.view.chart.period == "daily") {
        var date = new Date(technical.data[0].date);

        while (technical.data.length < 120) {
          date.setDate(date.getDate() - 1);
          while (date.getDay() == 0 || date.getDay() == 6) {
            date.setDate(date.getDate() - 1);
          }
          var d = {
            date: date.toISOString(),
            open: null,
            high: null,
            low: null,
            close: null,
            volume: null,
          };
          technical.data.splice(0, 0, d);
        }
      } else if (technical.view.chart.period == "1h") {
        var date = new Date(technical.data[0].date);

        while (technical.data.length < 120) {
          date.setHours(date.getHours() - 1);
          while (
            date.getDay() == 0 ||
            date.getDay() == 6 ||
            date.getHours() > 6
          ) {
            date.setHours(date.getHours() - 1);
          }
          var d = {
            date: date.toISOString(),
            open: null,
            high: null,
            low: null,
            close: null,
            volume: null,
          };
          technical.data.splice(0, 0, d);
        }
      } else if (technical.view.chart.period == "weekly") {
        var date = new Date(technical.data[0].date);

        while (technical.data.length < 120) {
          date.setDate(date.getDate() - 7);
          var d = {
            date: date.toISOString(),
            open: null,
            high: null,
            low: null,
            close: null,
            volume: null,
          };
          technical.data.splice(0, 0, d);
        }
      } else if (technical.view.chart.period == "monthly") {
        var date = new Date(technical.data[0].date);

        while (technical.data.length < 120) {
          date.setMonth(date.getMonth() - 1);
          var d = {
            date: date.toISOString(),
            open: null,
            high: null,
            low: null,
            close: null,
            volume: null,
          };
          technical.data.splice(0, 0, d);
        }
      }
    }

    if (
      technical.data.length == 0 &&
      technical == technical.view.chart.mainTechnical
    ) {
      technical.dataStatus = SvgChartTechnical.DATA_STATUS_NO_DATA;
      technical.view.onTechnicalDataStatusChange(technical);
      return;
    } else {
      technical.dataStatus = SvgChartTechnical.DATA_STATUS_OK;
    }

    technical.lastDataIndex = technical.data.length - 1;
    if (
      technical.view.mapping.benchmark &&
      technical.view.chart.period == "1m"
    ) {
      technical.data = technical.analysisAllDayBase(technical.data.length, 5);
      var now = new Date();
      var exchangeCode = technical.view.chart.exchange;
      var next_day = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate() + 2
      );
      var full_data = technical.analysisIntradayBase(
        technical.data,
        SvgChartGlobal.exchange[exchangeCode],
        technical.view.chart.period,
        next_day
      );

      technical.fillBlank(full_data);
      technical.abbreviate();

      var startIndex = SvgChartUtil.getStartIndex(
        technical.data,
        technical.data.length
      );
      technical.lastCloseStartIndex = startIndex - 1;
    } else if (
      technical == technical.view.chart.mainTechnical &&
      technical.view.chart.drawLastClose()
    ) {
      //		technical.data = technical.analysisAllDayBase(technical.data.length, 5);

      var now = new Date();
      var exchangeCode = technical.view.chart.exchange;
      var next_day = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate() + 2
      );
      var full_data = technical.analysisIntradayBase(
        technical.data,
        SvgChartGlobal.exchange[exchangeCode],
        technical.view.chart.period,
        next_day
      );

      // technical.lastDataIndex = technical.data.length - 1;
      technical.fillBlank(full_data);

      //		technical.abbreviate();
      for (var i = technical.data.length - 1; i >= 0; i--) {
        if (technical.data[i].close != null) {
          technical.lastDataIndex = i;
          break;
        }
      }

      var startIndex = SvgChartUtil.getStartIndex(
        technical.data,
        technical.data.length
      );

      technical.lastCloseStartIndex = startIndex - 1;

      if (technical.lastCloseStartIndex < 0)
        technical.dataStatus = SvgChartTechnical.DATA_STATUS_NO_DATA;

      var startIndex0 = SvgChartUtil.getStartIndex(
        technical.data,
        startIndex - 1
      );
      technical.twoDaysStartIndex = startIndex0;

      if (
        technical.view.chart.period == "1m" ||
        technical.view.chart.period == "5m"
      ) {
        var lastCloseIndex = startIndex - 1 >= 0 ? startIndex - 1 : 0;
        technical.lastCloseValue = technical.data[lastCloseIndex]["close"];
        var lastlastCloseIndex = startIndex0 - 1 >= 0 ? startIndex0 - 1 : 0;
        technical.lastlastCloseStartIndex = lastlastCloseIndex;
        technical.lastlastCloseValue =
          technical.data[lastlastCloseIndex]["close"];
      } else if (technical.lastCloseStartIndex >= 0) {
        technical.lastCloseValue =
          technical.data[technical.lastCloseStartIndex]["close"];
      }
    }

    if (technical == technical.view.chart.mainTechnical) {
      if (technical.view.chart.drawLastClose()) {
        technical.view.chart.minPageLength =
          technical.data.length - technical.lastCloseStartIndex;
      } else {
        technical.view.chart.minPageLength = Math.min(
          SvgChartGlobal.LAYOUT_SCROLL_MIN_PAGE_LENGTH,
          technical.data.length
        );
      }
    }

    if (
      technical.name == "pick" &&
      technical.view.chart.mainTechnical.dataStatus ==
        SvgChartTechnical.DATA_STATUS_OK
    ) {
      // technical.analysisPick(technical.view.chart.mainTechnical.data);
      technical.analysisPick2(technical.view.chart.mainTechnical.data);
      technical.view.mapping.updated = true;
    }
    if (
      technical == technical.view.chart.mainTechnical &&
      technical.view.chart.pickTechnical != null &&
      technical.view.chart.pickTechnical.data != null
    ) {
      technical.view.chart.pickTechnical.analysisPick2(technical.data);
      technical.view.mapping.updated = true;
    }

    if (
      technical.view.chart.newValueFunc != null &&
      technical == technical.view.chart.mainTechnical
    ) {
      technical.view.chart.newValueFunc(
        technical.data[technical.lastDataIndex].close,
        technical.lastCloseValue
      );
    }

    technical.view.onTechnicalDataStatusChange(technical);
  };

  SvgChartTechnical.prototype.analysisAllDayBase = function (endIndex, days) {
    if (days == 0) return [];
    if (endIndex == 0) return [];
    var startIndex = SvgChartUtil.getStartIndex(this.data, endIndex);
    // if (startIndex == 0) return [];

    var oneDayData = this.data.slice(startIndex, endIndex);

    var exchangeCode = this.view.chart.exchange;
    var base_data = this.analysisIntradayBase(
      oneDayData,
      SvgChartGlobal.exchange[exchangeCode],
      this.view.chart.period
    );
    var data = this.analysisBenchmark(oneDayData, base_data, 16);
    var data = this.analysisIntraday(data, base_data);

    var otherData = this.analysisAllDayBase(startIndex, days - 1);
    return otherData.concat(data);
  };

  SvgChartTechnical.prototype.loadData = function () {
    if (this.dataStatus == SvgChartTechnical.DATA_STATUS_OK) {
      this.view.onTechnicalDataStatusChange(this);
      return;
    }
    if (this.dataLoadType == SvgChartTechnical.DATA_LOAD_TYPE_WITH_MAIN) {
      this.dataStatus = SvgChartTechnical.DATA_STATUS_OK;
      this.view.onTechnicalDataStatusChange(this);
      return;
    } else if (this.dataLoadType == SvgChartTechnical.DATA_ANALYSIS) {
      if (this.view.chart.mainTechnical.data != null) {
        this.analysis.analysis(this, this.view.chart.mainTechnical.data);
      }
      this.dataStatus = SvgChartTechnical.DATA_STATUS_OK;
      this.view.onTechnicalDataStatusChange(this);
      return;
    }

    var data = SvgChartCache.load(this.dataLoadUrl);
    if (data != null) {
      SvgChartTechnical.loadSuccess(this, data);
      return;
    }

    var period = this.view.chart.period;
    var code = this.code;
    var call_back = "chart_callback";
    var jsonpCallbackFix = false;
    if (
      code == ".N225" ||
      code == ".TOPX" ||
      code == ".DJI" ||
      code == "JPY=X"
    ) {
      call_back =
        call_back +
        "_" +
        period +
        "_" +
        this.code.replace(".", "").replace("=", "");
      jsonpCallbackFix = true;
    }
    (function (technical) {
      SvgChartUtil.tech_jsonp({
        url: technical.dataLoadUrl,
        jsonpCallback: call_back,
        jsonpCallbackFix: jsonpCallbackFix,
        success: function (data) {
          // SvgChartGlobal.requestCount--;
          if (technical.view.chart.period != period) { return; }
          SvgChartCache.save(
            technical.dataLoadUrl,
            technical.view.chart.period,
            data
          );
          SvgChartTechnical.loadSuccess(technical, data);
        },
        fail: function () {
          SvgChartGlobal.requestCount--;
          if (technical.view.chart.period != period) {
            return;
          }
          technical.dataRetryCount += 1;
          if (technical.dataRetryCount < SvgChartTechnical.DATA_MAX_RETRY_COUNT) {
            technical.loadData();
          } else {
            technical.dataStatus = SvgChartTechnical.DATA_STATUS_FAILURE;
            technical.data = [];
            technical.view.onTechnicalDataStatusChange(technical);
          }
        },
      });
    })(this);

    this.view.onTechnicalDataStatusChange(this);
  };

  SvgChartTechnical.prototype.analysisIntraday = function (data, base_data) {
    if (data == null || base_data == null) return;

    var result = [];

    for (var i = 0; i < data.length; i++) {
      result.push({
        date: base_data[i].date,
        open: data[i].open,
        high: data[i].high,
        low: data[i].low,
        close: data[i].close,
        net_change: data[i].net_change,
        volume: data[i].volume,
        current_time: data[i].current_time,
      });
    }
    return result;
  };

  SvgChartTechnical.prototype.abbreviate = function () {
    var data = this.data;
    if (data == null || data.length == 0) return;
    var result = [];
    for (var i = 0; i < data.length; i++) {
      var m = data[i].date.substring(14, 16);
      if (parseInt(m) % 2 == 0) {
        result.push(data[i]);
      }
    }
    this.data = result;
  };

  SvgChartTechnical.prototype.analysisIntradayBase = function (
    data,
    exchangeTimes,
    period,
    current_time
  ) {
    if (data == null || data.length == 0) return;

    var result = [];
    var span;

    switch (period) {
      case "1h":
        span = 60;
        break;
      case "5m":
        span = 5;
        break;
      case "1m":
        span = 1;
        break;
    }
    span = span * 60 * 1000;
    var date = data[data.length - 1].date.substring(0, 10);
    var year = parseInt(date.substring(0, 4), 10);
    var month = parseInt(date.substring(5, 7), 10) - 1;
    var day = parseInt(date.substring(8, 10), 10);
    var data_timestamp;
    var gmtOffset = new Date().getTimezoneOffset() * 60 * 1000;
    // var current_time = data[0].date;
    if (current_time == null) {
      current_time = data[data.length - 1].current_time;
      current_time =
        current_time.substring(0, 10) +
        " " +
        current_time.substring(11, 19) +
        " +00";
      current_time = new Date(current_time);
    }
    // console.warn(data[data.length - 1].current_time);

    for (var i = 0; i < exchangeTimes.length; i++) {
      var label = exchangeTimes[i];
      var times = label.split(/:|\//);

      if (times.length != 2 && times.length != 4) {
        continue;
      }
      for (var t = 0; t < times.length; t++) {
        times[t] = parseInt(times[t]);
        if (isNaN(times[t])) {
          return data;
        }
      }

      var timestamp = Date.UTC(year, month, day, times[0], times[1]);
      if (i == 0) {
        data_timestamp = timestamp;
        result.push({
          date: new Date(data_timestamp + gmtOffset).format(
            "yyyy/MM/dd hh:mm:ss +00"
          ),
        });
        data_timestamp += span;
      } else {
        while (data_timestamp <= timestamp && data_timestamp < current_time) {
          result.push({
            date: new Date(data_timestamp + gmtOffset).format(
              "yyyy/MM/dd hh:mm:ss +00"
            ),
          });
          data_timestamp += span;
        }
      }

      if (times.length == 4) {
        timestamp = Date.UTC(year, month, day, times[2], times[3]);

        while (data_timestamp + span <= timestamp) {
          data_timestamp += span;
        }

        if (timestamp < current_time) {
          // data_timestamp = timestamp;
          result.push({
            date: new Date(data_timestamp + gmtOffset).format(
              "yyyy/MM/dd hh:mm:ss +00"
            ),
          });
          data_timestamp += span;
        } else {
          break;
        }
      }
    }
    if (period != "1m") {
      result = result.slice(0, result.length - 1);
    }
    return result;
  };

  SvgChartTechnical.prototype.fillBlank = function (fullData) {
    var index = SvgChartUtil.searchIndex(
      this.data[this.data.length - 1].date,
      fullData,
      0,
      fullData.length - 1,
      "next"
    );
    this.data = this.data.concat(fullData.slice(index + 1));
  };

  SvgChartTechnical.prototype.analysisLastClose = function (mainData) {
    if (
      this.data == null ||
      mainData == null ||
      this.data.length == 0 ||
      mainData.length == 0
    )
      return;

    if (mainData.length >= SvgChartGlobal.LASTDAY_REFERENCE_LIMIT) {
      var lastData = this.data[0];
      this.data = [];
      this.data[0] = lastData;
    }
  };

  //begin guhai 20141102
  SvgChartTechnical.prototype.analysisPick2 = function (mainData) {
    if (this.analysed == true) return;
    var startDate = new Date();
    // console.warn('Starting analysisPick2....');
    if (this.data == null || mainData == null) return;

    var result = [];
    var data = this.data;
    var mainIndex = 0;
    for (var i = 0; i < mainData.length; i++) {
      var mainDate = mainData[i].date;
      //console.warn("mainDate:"+mainDate);
      var existFlg = false;
      var pickData = null;
      for (var j = 0; j < data.length; j++) {
        pickData = data[j];
        var pickDate = pickData["start_time"]; //.substr(0,10);
        //mainDate is sorted asc,pickDate is sorted desc
        if (mainDate > pickDate) {
          break;
        }

        //console.warn("pickDate:"+pickDate);
        if (mainDate.substr(0, 10) == pickDate.substr(0, 10)) {
          existFlg = true;
          break;
        }
      }
      //result[i]=existFlg ? mainData[i].date : null;
      result[i] = existFlg ? pickData : null;
    }

    this.analysed = true;
    this.data = result;
    var endDate = new Date();
    var usedTime = endDate.getTime() - startDate.getTime();

    /**
	for (var i = 0; i < data.length; i++) {
		var start_time = data[i]["start_time"];

		if (mainData[mainIndex]&&mainData[mainIndex].date > start_time) {
			continue;
		}

		//otherwise index out of bounds exception
		while (mainIndex < mainData.length-1&&mainData[mainIndex].date < start_time) {
		//while (mainData[mainIndex].date < start_time && mainIndex < mainData.length) {
			result[mainIndex] = null;
			mainIndex++;
		}
		result[mainIndex] = data[i];
		mainIndex++;
	}
	result.shift();

	while (result.length < mainData.length) {
		result.push(null);
	}

	// console.warn(result);
	this.data = result;
	**/
  };
  //end guhai 20141102

  SvgChartTechnical.prototype.analysisPick = function (mainData) {
    if (
      this.data == null ||
      mainData == null ||
      this.data.length == 0 ||
      mainData.length == 0
    )
      return;

    var result = [];
    var data = this.data;
    var mainIndex = 0;
    for (var i = 0; i < data.length; i++) {
      var start_time = data[i]["start_time"];

      if (mainData[mainIndex].date > start_time) {
        continue;
      }

      while (
        mainData[mainIndex].date < start_time &&
        mainIndex < mainData.length
      ) {
        result[mainIndex] = null;
        mainIndex++;
      }
      result[mainIndex] = data[i];
      mainIndex++;
    }
    result.shift();

    while (result.length < mainData.length) {
      result.push(null);
    }

    // console.warn(result);
    this.data = result;
  };

  SvgChartTechnical.prototype.analysisBenchmark = function (
    data,
    mainData,
    date_len
  ) {
    if (data == null || mainData == null) return;
    date_len = date_len || 10;

    var result = [];
    var index = 1;
    // console.warn(mainData.length + " <=========> " + data.length);
    if (data.length > 0) {
      var minDate = data[0].date.substring(0, date_len);

      for (var i = 0; i < mainData.length; i++) {
        //			if (mainData[0].close != null && mainData[i].close == null) {
        if (mainData[i].close == null) {
          result[i] = mainData[i];
          continue;
        }

        // console.warn(i + " <=> " + index);
        var mainDate = mainData[i].date.substring(0, date_len);

        while (
          index < data.length &&
          mainDate >= data[index].date.substring(0, date_len)
        ) {
          index++;
        }

        if (mainDate < minDate) {
          result[i] = {
            date: mainData[i].date,
            open: null,
            high: null,
            low: null,
            close: null,
          };
        } else {
          result[i] = data[index - 1];
        }
      }
    }
    return result;
  };

  SvgChartTechnical.id = 0;

  SvgChartTechnical.prototype.setName = function (chart, name) {
    var globalViewConfig = chart.chartConfig.globalViewConfig;
    var viewConfig = chart.chartConfig.viewConfig;
    var technicalConfig = chart.chartConfig.technicalConfig[name];

    var config;
    if (technicalConfig && technicalConfig.type != undefined && technicalConfig.type === "sub") {
      config = MST.deepMerge(globalViewConfig, viewConfig.sub);
    } else {
      config = MST.deepMerge(globalViewConfig, viewConfig.main);
    }
    config = MST.deepMerge(config, technicalConfig);

    this.techId = SvgChartTechnical.id++;
    this.name = name;
    if (technicalConfig) {

      this.colorIsConstant = technicalConfig.colorIsConstant;
      if (this.colorIsConstant) {
        this.dataColor = technicalConfig.dataColor;
      } else {
        this.dataColor = [];
        this.lineWidth = [];

        for (var i = 0; i < technicalConfig.dataColor.length; i++) {
          this.dataColor.push(
            SvgChartGlobal.COLOR_PANEL[technicalConfig.dataColor[i]]
          );
          this.lineWidth.push(SvgChartGlobal.LINE_WIDTH[0]);
        }
        if (technicalConfig.dataFillcolor) {
          this.dataFillcolor = technicalConfig.dataFillcolor;
        }
      }
      if (technicalConfig.cancellable != undefined) {
        this.cancellable = technicalConfig.cancellable;
      }
      if (technicalConfig.maxCount != undefined) {
        this.maxCount = technicalConfig.maxCount;
      }

      this.plural = technicalConfig.plural;
      this.labelShowParam = technicalConfig.labelShowParam;
      this.type = technicalConfig.type;
      this.dataColorSelect = technicalConfig.dataColorSelect;

      if (
        technicalConfig.dataColorLabel == null ||
        technicalConfig.dataColorLabel.length == 0
      ) {
        this.dataColorLabel = technicalConfig.labels;
      } else {
        this.dataColorLabel = technicalConfig.dataColorLabel;
      }
      this.dataLoadType = technicalConfig.loadType;
      this.labels = technicalConfig.labels;
      this.analysis = technicalConfig.analysis;
      if (technicalConfig.params != null) {
        this.params = technicalConfig.params.concat();
      }
      if (technicalConfig.paramLabels != null) {
        this.paramLabels = technicalConfig.paramLabels;
      }
      if (technicalConfig.paramMaxLengths != null) {
        this.paramMaxLengths = technicalConfig.paramMaxLengths;
      }
      this.projectorType = technicalConfig.projectorType;
      this.dataLoadName = technicalConfig.dataName;
    }

    this.layout = config.layout;
    this.vAxis = config.vAxis;
    this.hAxis = config.hAxis;
    this.panel = config.panel;
  };

  MST.SvgChartTechnical = SvgChartTechnical;
})();

Date.prototype.Format = function (fmt) {
  var o = {
    "M+": this.getMonth() + 1,
    "d+": this.getDate(),
    "h+": this.getHours(),
    "m+": this.getMinutes(),
    "s+": this.getSeconds(),
    "q+": Math.floor((this.getMonth() + 3) / 3),
    S: this.getMilliseconds(),
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
  return fmt;
};
